import { render } from "./Tsetsenekou.vue?vue&type=template&id=24a2fa7b"
import script from "./Tsetsenekou.vue?vue&type=script&lang=js"
export * from "./Tsetsenekou.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__